export const CREATE_BRANDS_REQUEST = "CREATE_BRANDS_REQUEST";
export const CREATE_BRANDS_SUCCESS = "CREATE_BRANDS_SUCCESS";
export const CREATE_BRANDS_FAIL = "CREATE_BRANDS_FAIL";
export const GET_ALL_BRANDS_REQUEST = "GET_ALL_BRANDS_REQUEST";
export const GET_ALL_BRANDS_SUCCESS = "GET_ALL_BRANDS_SUCCESS";
export const GET_ALL_BRANDS_FAIL = "GET_ALL_BRANDS_FAIL";
export const DELETE_BRANDS_REQUEST = "DELETE_BRANDS_REQUEST";
export const DELETE_BRANDS_SUCCESS = "DELETE_BRANDS_SUCCESS";
export const DELETE_BRANDS_FAIL = "DELETE_BRANDS_FAIL";
